import { getCarousels } from '@/core/api'

export default {
  namespaced: true,
  state: {
    carousels: sessionStorage.getItem('carousels')
      ? JSON.parse(sessionStorage.getItem('carousels'))
      : false
  },
  mutations: {
    carousels(state, carousels) {
      state.carousels = carousels
    },
    fetch(state, carousels) {
      state.carousels = carousels
      sessionStorage.setItem('carousels', JSON.stringify(carousels))
    },
    reset(state) {
      state.carousels = false
      sessionStorage.removeItem('carousels')
    }
  },
  actions: {
    carousels({ commit }, carousels) {
      commit('carousels', carousels)
    },
    async fetch({ commit, state }) {
      if (state.carousels === false) {
        const res = await getCarousels()
        if (res.status === 200) {
          commit('fetch', res.data)
        }
      }
    },
    reset({ commit, state }) {
      commit('reset', state)
    }
  },
  getters: {
    carousels: state => {
      return state.carousels
    }
  }
}
